import { doc, getDoc, increment, updateDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "./firebase";

export default function Track() {
  const { slug } = useParams();
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function track() {
      if (!slug) {
        setError("Missing tracking link.");
        return;
      }

      try {
        const reference = doc(db, "links", slug);
        const snapshot = await getDoc(reference);

        if (!snapshot.exists()) {
          if (!cancelled) {
            setError("Tracking link not found.");
          }
          return;
        }

        const data = snapshot.data();

        if (!data.destinationUrl || data.status === "archived") {
          if (!cancelled) {
            setError("This tracking link is no longer active.");
          }
          return;
        }

        await updateDoc(reference, {
          clicks: increment(1)
        });

        window.location.replace(data.destinationUrl);
      } catch (trackError) {
        if (!cancelled) {
          setError(trackError.message);
        }
      }
    }

    track();

    return () => {
      cancelled = true;
    };
  }, [slug]);

  return (
    <div className="container">
      <div className="card">
        <h1>Redirecting...</h1>
        <p>{error || "We are sending your visitor to the destination URL now."}</p>
      </div>
    </div>
  );
}
